<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="banner">
      <el-carousel
        :interval="5000"
        arrow="never"
        ref="cardShow"
        class="wow animate__animated animate__zoomIn"
      >
        <el-carousel-item v-for="item in imglist" :key="item.img_url">
          <div class="banner-img">
            <img :src="item.img_url" alt="" width="100%" height="100%" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- PC内容 -->
    <section class="content" v-if="!isPhone">
      <!-- 案例 -->
      <section class="case">
        <div class="title-container">
          <img :src="bgImg.title_img_url" alt="" class="title-img case-title" />
          <img src="../assets/CompanyCaseTitle@2x.png" alt="" />
        </div>
        <div class="case-conten">
          <div class="list-container">
            <div
              class="item wow animate__animated"
              data-wow-offset="400"
              :class="
                index === 0 || index === 1
                  ? 'animate__slideInLeft'
                  : 'animate__slideInRight'
              "
              v-for="(item, index) in caseList"
              :key="item.id"
              @click="goCaseDetail(item)"
            >
              <div class="item-top">
                <div class="case-desc-smark">
                  <p>{{ item.intro }}</p>
                </div>
                <img :src="item.intro_img" alt="" width="273" height="364" />
              </div>
              <div class="item-bottom">
                <span>{{ item.name }}</span>
                <span>{{ item.time }}</span>
              </div>
            </div>
            <div class="img-dec img-bg" :style="caseImgDec"></div>
          </div>
        </div>
        <div class="more" @click="goCase()">查看更多</div>
      </section>
      <!-- 公司动态 -->
      <section class="dynamics" :style="dynamicsImgBg">
        <div class="title-container">
          <img :src="bgImg.title_img_url" alt="" class="title-img" />
          <img src="../assets/CompanyTrendsTitle@2x.png" class="mg-left" alt="" />
        </div>
        <div class="trends wow animate__animated animate__slideInDown">
          <el-carousel
            :interval="4000"
            type="card"
            arrow="never"
            :autoplay="false"
          >
            <el-carousel-item v-for="(item, index) in trendsList" :key="index">
              <div @click="goTrend(item.id)">
                <img :src="item.main_img_url" alt="" width="400" height="300" />
                <div class="trends-bottom">
                  <p class="trends-bottom-text">
                    {{ item.intro }}
                  </p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </section>
      <!-- 关于我们 -->
      <section class="about">
        <div class="title-container">
          <img
            :src="bgImg.title_img_url"
            alt=""
            class="title-img about-title"
          />
          <img src="../assets/AboutUsTitle@2x.png" alt="" />
        </div>
        <section class="img-and-dec">
          <div class="left-img" :style="aboutImgDecLeft"></div>
          <div class="right-img" :style="aboutImgDecRight"></div>
          <div class="img" :style="aboutImgShow"></div>
          <div class="us-desc wow animate__animated animate__zoomInRight">
            <div class="us-desc-left-box"></div>
            <p>
              广州巅峰汇影视文化发展有限公司，成立于2011年，总部位于广州，立足于华南地区影视制作，专注于出品院线电影、互联网电影、网剧、短视频等网生内容，打造互联网影视头部内容IP产业链。
            </p>
            <p>
              公司属广东电影家协会理事、广东省影视协会副会长单位，主创团队是业内资深电影人，拥有优秀的内容运营团队以及制作团队，组成一个互联网电影、网剧、短视频等网络内容投资、策划、制作、营销的生产与孵化平台，致力于成为一个走在行业前端的数字娱乐内容生产者。
            </p>
          </div>
        </section>
      </section>
      <!-- 联系我们 -->
      <section class="contact" :style="contactUsImgBg">
        <div class="title-container">
          <img
            :src="bgImg.title_img_url"
            alt=""
            class="title-img about-title"
          />
          <img src="../assets/ContactUsTitle@2x.png" alt="" />
        </div>
        <div class="contact-desc wow animate__animated animate__zoomInUp">
          <p>
            <img src="../assets/Local@3x.png" alt="" class="local-img" />
            <span>地址：中国广州市海珠区敦和路189路海珠科技园C栋C206</span>
          </p>
          <p>
            <img src="../assets/PhoneCall@3x.png" alt="" class="local-img" />
            <span>电话：020-84264529</span>
          </p>
        </div>
      </section>
    </section>
    <!-- 移动端 -->
    <section class="phone-content" v-else>
      <!-- 案例 -->
      <section class="phone-case">
        <div class="phone-title-container">
          <img :src="bgImg.title_img_url" alt="" class="phone-title-img" />
          <img
            class="phone-title-text"
            src="../assets/CompanyCaseTitle@2x_phone.png"
            alt=""
          />
        </div>
        <div class="phone-case-conten">
          <div class="phone-item">
            <div
              class="item wow animate__animated"
              data-wow-offset="400"
              :class="
                index === 0 || index === 1
                  ? 'animate__slideInLeft'
                  : 'animate__slideInRight'
              "
              :style="index % 2 === 0 ? 'margin-left:0' : 'margin-left:16px'"
              v-for="(item, index) in caseList"
              :key="item.id"
              @click="goCaseDetail(item)"
            >
              <div class="item-top">
                <div class="case-desc-smark">
                  <p>{{ item.intro }}</p>
                </div>
                <img :src="item.intro_img" alt="" width="273" height="364" />
              </div>
              <div class="item-bottom">
                <span>{{ item.name }}</span>
                <span>{{ item.time }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="more" @click="goCase()">查看更多</div>
      </section>
      <!-- 公司动态 -->
      <section class="phone-dynamics">
        <div class="phone-title-container">
          <img :src="bgImg.title_img_url" alt="" class="phone-title-img" />
          <img
            class="phone-title-text"
            src="../assets/DynamicsTitle@2x_phone.png"
            alt=""
          />
        </div>
        <div class="phone-trends wow animate__animated animate__slideInDown">
          <el-carousel
            :interval="4000"
            type="card"
            arrow="never"
            :autoplay="false"
            width="375"
          >
            <el-carousel-item v-for="(item, index) in trendsList" :key="index">
              <div @click="goTrend(item.id)">
                <img :src="item.main_img_url" alt="" width="267" height="200" />
                <div class="phone-trends-bottom">
                  <p class="phone-trends-bottom-text">
                    {{ item.intro }}
                  </p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </section>
      <!-- 关于我们 -->
      <section class="phone-about">
        <div class="phone-title-container">
          <img :src="bgImg.title_img_url" alt="" class="phone-title-img" />
          <img
            class="phone-title-text"
            src="../assets/AboutUsTitle_phone@2x.png"
            alt=""
          />
        </div>
        <div class="about-content">
          <img src="../assets/AboutUs_img@2x.png" alt="" />
          <div class="phone-desc">
            <div
              class="phone-us-desc wow animate__animated animate__zoomInRight"
            >
              <div class="phone-us-desc-left-box"></div>
              <p>
                广州巅峰汇影视文化发展有限公司，成立于2011年，总部位于广州，立足于华南地区影视制作，专注于出品院线电影、互联网电影、网剧、短视频等网生内容，打造互联网影视头部内容IP产业链。
              </p>
              <p>
                公司属广东电影家协会理事、广东省影视协会副会长单位，主创团队是业内资深电影人，拥有优秀的内容运营团队以及制作团队，组成一个互联网电影、网剧、短视频等网络内容投资、策划、制作、营销的生产与孵化平台，致力于成为一个走在行业前端的数字娱乐内容生产者。
              </p>
            </div>
          </div>
        </div>
      </section>
      <!-- 联系我们 -->
      <section class="phone-contact">
        <div class="phone-title-container">
          <img :src="bgImg.title_img_url" alt="" class="phone-title-img" />
          <img
            class="phone-title-text"
            src="../assets/ContactUsTitle_phone@2x.png"
            alt=""
          />
        </div>
        <div
          class="phone-contact-content wow animate__animated animate__zoomInUp"
        >
          <p>
            <img src="../assets/Local@3x.png" alt="" class="phone-local-img" />
            <span>地址：中国广州市海珠区敦和路189路海珠科技园C栋C206</span>
          </p>
          <p>
            <img
              src="../assets/PhoneCall@3x.png"
              alt=""
              class="phone-local-img"
            />
            <span>电话：020-84264529</span>
          </p>
        </div>
        <img
          :src="bgImg.foot_bg_img_url"
          class="phone-contact-img"
        />
      </section>
    </section>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import {
  getSwiperList,
  getMovieList,
  getMobileSwiperList,
  getManagementList,
  getBackgroundImg,
} from "@/api";
import { formatDate, isMobile } from "@/utils";
import { mapState } from "vuex";

export default {
  data() {
    return {
      imglist: [
        {
          id: "1",
          img_url: "http://www.itmg.cn/u/cms/www/202302/1316081479vx.jpg",
          description: "描述",
          name: "轮播1",
        },
        {
          id: "2",
          img_url: "http://www.itmg.cn/u/cms/www/202302/1316081479vx.jpg",
          description: "描述",
          name: "轮播1",
        },
        {
          id: "3",
          img_url: "http://www.itmg.cn/u/cms/www/202302/1316081479vx.jpg",
          description: "描述",
          name: "轮播1",
        },
        {
          id: "4",
          img_url: "http://www.itmg.cn/u/cms/www/202302/1316081479vx.jpg",
          description: "描述",
          name: "轮播1",
        },
        {
          id: "5",
          img_url: "http://www.itmg.cn/u/cms/www/202302/1316081479vx.jpg",
          description: "描述",
          name: "轮播1",
        },
      ],
      caseList: [
        {
          id: 1,
          intro_img: require("../assets/CompanyCase1_img@2x.png"),
          name: "封神",
          time: "2022/12/23",
          imgs_url: [],
          type: "1",
          intro:
            "这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介",
        },
        {
          id: 1,
          img_url: require("../assets/CompanyCase1_img@2x.png"),
          name: "封神",
          time: "2022/12/23",
          imgs_url: [],
          type: "1",
          intro:
            "这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介",
        },
        {
          id: 1,
          img_url: require("../assets/CompanyCase1_img@2x.png"),
          name: "封神",
          time: "2022/12/23",
          imgs_url: [],
          type: "1",
          intro:
            "这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介",
        },
        {
          id: 1,
          img_url: require("../assets/CompanyCase1_img@2x.png"),
          name: "封神",
          time: "2022/12/23",
          imgs_url: [],
          type: "1",
          intro:
            "这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介这是简介",
        },
      ],
      trendsList: [
        {
          id: 1,
          main_img_url: require("../assets/trends_img1@2x.png"),
          author: "作者作者",
          title: "动态标题",
          time: "2022/12/01",
          intro: "sasa",
          introduction:
            "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介",
          description:
            " 恭喜电影《生死交锋》好事成双[强],入围第十五届澳门国际电影节 和十九届中美电影节巅峰汇联合 出品，期待电影早日上映！",
        },
        {
          id: 2,
          main_img_url: require("../assets/trends_img1@2x.png"),
          author: "作者作者",
          title: "动态标题",
          time: "2022/12/01",
          introduction:
            "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介",
          description:
            " 恭喜电影《生死交锋》好事成双[强],入围第十五届澳门国际电影节 和十九届中美电影节巅峰汇联合 出品，期待电影早日上映！",
        },
        {
          id: 3,
          main_img_url: require("../assets/trends_img1@2x.png"),
          author: "作者作者",
          title: "动态标题",
          time: "2022/12/01",
          introduction:
            "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介",
          description:
            " 恭喜电影《生死交锋》好事成双[强],入围第十五届澳门国际电影节 和十九届中美电影节巅峰汇联合 出品，期待电影早日上映！",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      bgImg: (state) => state.bgImg,
      isPhone: (state) => state.isPhone,
    }),
    caseImgDec() {
      return `background-image: url(${encodeURI(
        this.bgImg.case_dec_img_url
      )});`;
    },
    dynamicsImgBg() {
      return `background-image: url(${encodeURI(
        this.bgImg.dynamics_bg_img_url
      )});`;
    },
    aboutImgDecLeft() {
      return `background-image: url(${encodeURI(
        this.bgImg.about_dec_img_url_left
      )});`;
    },
    aboutImgDecRight() {
      return `background-image: url(${encodeURI(
        this.bgImg.about_dec_img_url_right
      )});`;
    },
    aboutImgShow() {
      return `background-image: url(${encodeURI(
        this.bgImg.about_show_img_url
      )});`;
    },
    contactUsImgBg() {
      return `background-image: url(${encodeURI(this.bgImg.foot_bg_img_url)});`;
    },
  },
  methods: {
    async init() {
      const data = {
        page: 1,
        size: 4,
      };
      getBackgroundImg().then((res) => {
        res.data[0] && this.$store.commit("changeBgImg", res.data[0]);
      });
      const resSwiper = isMobile()
        ? await getMobileSwiperList()
        : await getSwiperList();
      const resCase = await getMovieList(data);
      const resTrends = await getManagementList();
      this.imglist = resSwiper.data;
      this.caseList = resCase.data;
      this.caseList.forEach((item) => {
        item.time = formatDate(item.time);
      });
      this.trendsList = resTrends.data;
    },
    goCase() {
      this.$router.push("/case");
    },
    goCaseDetail(item) {
      this.$router.push(`/caseDetail/${item.id}`);
    },
    goTrend(id) {
      this.$router.push({
        path: "/dynamics",
        query: {
          id: id,
        },
      });
    },
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.init();
    var wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();
  },
};
</script>

<style lang="less" scoped>
.home {
  background: black;
}
img {
  display: block;
}
.banner {
  height: 800px;
  position: relative;
  margin-top: 96px;
  .banner-img {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .banner-img img {
    width: 100%;
    min-height: 43%;
    // height: auto;
    // object-fit: cover;
  }
  /deep/ .is-active .el-carousel__button {
    width: 76px;
    background-color: #fec527 !important;
  }
  /deep/ .el-carousel__button {
    width: 36px;
    height: 8px;
    margin: 0 auto;
    background: rgb(145, 129, 129);
    transform: skewX(-45deg);
  }
  /deep/ .el-carousel__container {
    height: 800px !important;
  }
}
.content {
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
// 背景图铺满
.img-bg {
  background-size: 100% 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

// 案例
.case {
  height: 1001px;
  width: 1920px;
  background-size: 100% 100%;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  .title-container {
    padding-top: 109px;
  }
  .case-conten {
    .img-dec {
      position: absolute;
      right: -176px;
      top: 114px;
      width: 176px;
      height: 250px;
      background-image: url("../assets/clipper@2x.png");
    }
  }
  .list-container {
    position: relative;
    width: 1200px;
    display: flex;
    justify-content: space-between;
    margin: 78px auto 0 auto;
    z-index: 2;
  }
  .item {
    width: 273px;
    margin-right: 35px;
    z-index: 9;
  }
  .item-top {
    position: relative;
    width: 100%;
    height: 364px;
    cursor: pointer;
  }
  .item-top:hover .case-desc-smark {
    opacity: 1;
    bottom: 0;
    filter: alpha(opacity=100);
  }
  .item-top {
    height: auto;
  }
  .case-desc-smark {
    position: absolute;
    bottom: -2%;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    transition: 400ms;
    filter: alpha(opacity=0);
    opacity: 0;
    padding-bottom: 17px;
  }
  .case-desc-smark p {
    color: #ffff;
    font-size: 14px;
    padding: 20px;
    text-align: left;
    line-height: 25px;
    text-indent: 2em;
    max-height: 90px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    height: 80px;
    overflow: hidden;
  }
  .item-top:hover .case-desc-smark {
    opacity: 1;
    bottom: 0;
    filter: alpha(opacity=100);
  }
  .item-bottom {
    width: calc(100% - 24px);
    height: 57px;
    background: linear-gradient(
      90deg,
      hsla(0, 0%, 85%, 0.2),
      hsla(0, 0%, 93%, 0)
    );
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
  }
  .item-bottom span:nth-child(1) {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 25px;
    width: 50%;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-bottom span:nth-child(2) {
    font-size: 14px;
    font-family: "PingFang-SC";
    font-weight: 400;
    color: #ffffff;
    line-height: 25px;
    opacity: 0.7;
  }
  .item-bottom {
    width: 152px;
    padding: 0 4px;
    height: 38px;
  }
  .item-bottom {
    width: calc(100% - 8px);
  }
  .more {
    width: 160px;
    height: 48px;
    border-radius: 28px;
    border: 1px solid #979797;
    margin: 50px auto 128px auto;
    font-size: 18px;
    font-family: "PingFang-SC";
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
  .more:hover {
    color: #fec527;
    border-color: #fec527;
  }
}
// 公司动态
.dynamics {
  background-image: url("../assets/home_2@2x.png");
  height: 870px;
  width: 100%;
  max-width: 1921px;
  background-size: 100% 100%;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  margin-top: -1px;
  .title-container {
    margin-bottom: 80px;
  }
  .mg-left{
      margin-left: 0.9%;
    }
  .trends {
    width: 65%;
    margin: 0 auto;
    position: absolute;
    left: 22%;
  }

  .trends-bottom {
    background: #ffffff;
    padding: 20px 24px 55px 24px;
    min-height: 75px;
  }

  .trends-bottom-text {
    font-size: 18px;
    font-family: "PingFang-SC";
    font-weight: 400;
    color: #1d2129;
    line-height: 25px;
    text-align: initial;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    height: 100px;
    overflow: hidden;
  }
  /deep/ .trends .el-carousel__container {
    height: 450px !important;
    width: 1199px !important;
    overflow: hidden;
  }

  /deep/ .trends .el-carousel__item {
    width: 400px;
  }

  /deep/ .trends .el-carousel__indicators--outside {
    margin-top: 67px;
    margin-left: -11%;
  }

  .trends /deep/ .is-active .el-carousel__button {
    width: 12px;
    background-color: #fec527 !important;
    height: 12px;
    opacity: 1;
  }

  .trends /deep/ .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #fec527;
    opacity: 0.6;
  }

  .trends /deep/ .el-carousel__item,
  .el-carousel__mask {
    left: 2%;
  }

  /deep/ .el-carousel__mask {
    background-color: #000;
    opacity: 0.4;
  }
}
// 关于我们
.about {
  height: 847px;
  width: 100%;
  background-size: 100% 100%;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  margin-top: -1px;
  .title-container {
    margin-bottom: 80px;
  }
  .img-and-dec {
    position: relative;
    width: 1200px;
    height: 510px;
    margin: 0px auto;
    .left-img {
      position: absolute;
      top: -85px;
      left: -150px;
      width: 126px;
      height: 151px;
      background-size: 100% 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../assets/film@2x.png");
    }
    .right-img {
      position: absolute;
      top: 100px;
      right: -41px;
      width: 134px;
      height: 120px;
      background-size: 100% 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../assets/camera@2x.png");
    }
    .img {
      width: 1060px;
      height: 387px;
      background-size: 100% 100%;
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("../assets/AboutUs_img@2x.png");
    }
  }
  .us-desc {
    width: 578px;
    padding: 26px 24px;
    font-size: 16px;
    font-family: "PingFang-SC";
    font-weight: 400;
    color: #ffffff;
    line-height: 25px;
    position: absolute;
    bottom: 0;
    right: 0;
    background: #333333;
    z-index: 2;
    text-align: left;
    p {
      margin-bottom: 20px;
    }
    .us-desc-left-box {
      width: 54px;
      height: 160px;
      background-color: #fec527;
      position: absolute;
      left: -54px;
      bottom: 20px;
    }
  }
  .us-desc p:nth-child(1) {
    margin-bottom: 20px;
  }
  .us-desc p {
    font-size: 14px !important;
  }
}
// 联系我们
.contact {
  background-image: url("../assets/home_4@2x.png");
  height: 724px;
  width: 100%;
  background-size: 100% 100%;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  margin-top: -1px;
  color: #ffffff;
  .contact-desc {
    width: 64%;
    margin: 0 auto;
    padding-top: 73px;
  }
  .contact-desc p {
    margin-bottom: 14px;
    display: flex;
  }
  .local-img {
    width: 24px;
    height: 24px;
    margin-right: 14px;
    display: inline-block;
  }
}

// 标题
.title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title-img {
    width: 777px;
    height: 89px;
  }
}
.title-container img:nth-child(2) {
  height: 56px;
}

// 移动端

.phone-content {
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  // 案例
  .phone-case {
    width: 100%;
    .phone-case-conten {
      .phone-item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
      }
      .item {
        width: 160px;
        height: 240px;
        color: #fff;
        .item-top {
          width: 160px;
          height: 203px;
          position: relative;
          .case-desc-smark {
            position: absolute;
            overflow: hidden;
            bottom: 0px;
            bottom: -2%;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.6);
            transition: 400ms;
            filter: alpha(opacity=0);
            opacity: 0;
          }
          .case-desc-smark p {
            color: #ffff;
            font-size: 10px;
            text-align: left;
            text-indent: 2em;
            padding: 5px;
            text-overflow: ellipsis; /* 当文字溢出时显示省略号 */
            display: -webkit-box; /* 必须指定display为-webkit-box才能生效 */
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            height: 80%;
            overflow: hidden;
          }

          .item-top:hover .case-desc-smark {
            opacity: 1;
            bottom: 0;
            filter: alpha(opacity=100);
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item-bottom {
          background: linear-gradient(
            90deg,
            rgb(216 216 216 / 20%) 0%,
            rgba(238, 238, 238, 0) 100%
          );
          width: 152px;
          padding: 0 4px;
          height: 38px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .item-bottom span:nth-child(1) {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 25px;
          width: 50%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .item-bottom span:nth-child(2) {
          font-size: 14px;
          font-family: "PingFang-SC";
          font-weight: 400;
          color: #ffffff;
          line-height: 25px;
          opacity: 0.7;
        }
      }
    }
    .more {
      border-radius: 28px;
      border: 1px solid #979797;
      font-family: "PingFang-SC";
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
      margin: 0 auto 0px auto;
      font-size: 14px;
      line-height: 30px;
      height: 30px;
      width: 100px;
    }
    .more:hover {
      color: #fec527;
      border-color: #fec527;
    }
  }

  .phone-trends-bottom-text {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  // 公司动态
  .phone-dynamics {
    .phone-trends {
      width: 100%;
      /deep/ .el-carousel {
        width: 375px;
      }
      /deep/ .el-carousel__item {
        width: 267px !important;
        overflow: hidden;
      }
      /deep/ .el-carousel__item img {
        width: 267px;
        height: 200px;
      }
      /deep/ .el-carousel__item.is-active {
        margin-left: -9.5%;
      }
      .el-carousel__item,
      .el-carousel__mask {
        left: -0.8%;
      }
      /deep/ .el-carousel__container {
        height: 300px !important;
      }
      /deep/ .el-carousel__indicators--outside {
        margin-top: 21px !important;
        margin-left: 0;
      }

      /deep/ .is-active .el-carousel__button {
        width: 12px;
        background-color: #fec527 !important;
        height: 12px;
        opacity: 1;
      }

      /deep/ .el-carousel__button {
        width: 8px;
        height: 8px;
        background: #fec527;
        opacity: 0.6;
      }
    }
    .phone-trends-bottom {
      padding: 12px 13px 12px 12px;
      height: 104px;
      background-color: #fff;
      font-size: 14px;
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
  // 关于我们
  .phone-about {
    .about-content {
      img {
        width: 350px;
        height: 124px;
      }
    }
    .phone-desc {
      display: flex;
      justify-content: flex-end;
    }
    .phone-us-desc {
      width: 300px;
      height: 240px;
      padding: 16px;
      font-size: 14px;
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      position: relative;
      bottom: 0;
      right: 0;
      background: #333333;
      z-index: 2;
      text-align: left;
      margin-top: 16px;
      p {
        margin-bottom: 20px;
      }
      .phone-us-desc-left-box {
        width: 20px;
        height: 84px;
        background-color: #fec527;
        position: absolute;
        left: -20px;
        top: 35px;
      }
    }
    .phone-us-desc p:nth-child(1) {
      margin-bottom: 20px;
    }
  }
  // 联系我们
  .phone-contact {
    .phone-contact-content {
      width: 288px;
      height: 70px;
      font-size: 14px;
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin-left: 16%;
      .phone-local-img {
        width: 19px;
        height: 19px;
        margin-right: 10px;
      }
      p {
        display: flex;
      }
    }
    .phone-contact-img {
      width: calc(100vw - 0px);
    }
  }

  // 模块标题
  .phone-title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 32px;
    .phone-title-img {
      width: 350px;
      height: 40px;
    }
    .phone-title-text {
      width: 283px;
      height: 37px;
    }
  }
}
/* 2K */
@media screen and (min-width: 2560px) {
  .banner {
    height: 75vh;
  }

  .banner /deep/.el-carousel__container {
    height: 75vh !important;
  }

  .item-list {
    display: flex;
    align-items: baseline;
    position: relative;
    width: 1200px;
    margin: 78px auto 0 auto;
  }

  .item-list .icon-img {
    width: 360px;
    height: 545px;
    position: absolute;
  }

  .icon-img-left {
    left: -30%;
    top: -24%;
  }

  .icon-img-right {
    right: -30%;
    top: -24%;
  }

  .case {
    background-position-y: -136px;
    background-position-x: 85px;
  }

  .trends {
    width: auto;
    left: 30%;
  }

  .about-us {
    padding-top: 20%;
  }

  .contact-us {
    min-height: 520px;
  }
}

@media screen and (max-width: 768px) {
  .home {
    margin-top: 60px;
  }
  .banner {
    margin-top: 0px;
    height: 337px;
  }
  .banner /deep/ .el-carousel__container {
    height: 337px !important;
  }
}
</style>
